import { Route, Switch } from 'react-router-dom'
import { Home } from './home'
import { CreateDataset } from '../datasets/create-dataset'
import { ResubmitDataset } from '../datasets/resubmit-dataset'

export const Submissions = () => {
  return (
    <Switch>
      <Route path="/codes/update/:templateId/:datasetId" component={CreateDataset} />
      <Route path="/codes/create/:templateId" component={CreateDataset} />
      <Route path="/codes/resubmit/:datasetId" component={ResubmitDataset} />
      <Route path="/codes" component={Home} />
    </Switch>
  )
}
